function getShortHash(hash: string) {
  if (!hash) {
    return '';
  }

  return `${hash.slice(0, 10)}...`;
}

export default getShortHash;
